module.exports = __webpack_public_path__ + "static/media/background-portais.06f800b0.svg";